/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: Vfkq2Yx57uAC
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import AppShell from "../../AppShell"; // plasmic-import: Apa7akI9fuQs/component
import TabLayout from "../../TabLayout"; // plasmic-import: 0i0g7bSenwRJ/component
import Dock from "../../Dock"; // plasmic-import: diB0qQnqZI7L/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: n-yL9NcVDVDg/component
import ButtonDock from "../../ButtonDock"; // plasmic-import: mzA6SGO_FrzS/component
import PageLayout from "../../PageLayout"; // plasmic-import: 6gaQHJJIqual/component
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: hEgWOAymJgYc/component
import ButtonSecondary from "../../ButtonSecondary"; // plasmic-import: gdah8X0wiLGH/component
import SectionFooter from "../../SectionFooter"; // plasmic-import: f7EdRjw-ChvD/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: Vfkq2Yx57uAC/css
import Icon6Icon from "./icons/PlasmicIcon__Icon6"; // plasmic-import: o3Knj9MueGQA/icon
import Icon12Icon from "./icons/PlasmicIcon__Icon12"; // plasmic-import: H2aWiH48hSbz/icon
import image2RcDhf2RmVmG from "./images/image2.svg"; // plasmic-import: RcDhf_2RMVmG/picture
import image7MdrMmtCqfnyU from "./images/image7.svg"; // plasmic-import: mdrMmtCqfnyU/picture
import image16HUd1Hbxq734L from "./images/image16.png"; // plasmic-import: hUD1HBXQ734L/picture

createPlasmicElementProxy;

export const PlasmicHomepage__VariantProps = new Array();

export const PlasmicHomepage__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.root
          )}
        >
          <AppShell
            data-plasmic-name={"appShell"}
            data-plasmic-override={overrides.appShell}
            appShell={
              <TabLayout
                data-plasmic-name={"tabLayout"}
                data-plasmic-override={overrides.tabLayout}
                className={classNames("__wab_instance", sty.tabLayout)}
                layoutType={"verticalStacked"}
                tabContent={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__naeFo)}
                  >
                    <PageLayout
                      data-plasmic-name={"pageLayout"}
                      data-plasmic-override={overrides.pageLayout}
                      layoutSections={"withoutNav"}
                      pageContent={
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__poIt0
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__adf2R
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                sty.freeBox__lHDhE
                              )}
                            >
                              <div
                                className={classNames(
                                  projectcss.all,
                                  sty.freeBox__qYkBv
                                )}
                              >
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.text__xi1Xu
                                  )}
                                >
                                  {"outsourcing platform for your practice."}
                                </div>
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    sty.freeBox__lOXa9
                                  )}
                                >
                                  <div
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.__wab_text,
                                      sty.text__h7Q37
                                    )}
                                  >
                                    {
                                      "One place to find, connect with, and delegate work to specialists who handle what your team doesn\u2019t have time for."
                                    }
                                  </div>
                                </div>
                              </div>
                              <div
                                className={classNames(
                                  projectcss.all,
                                  sty.freeBox___1QvtS
                                )}
                              >
                                <ButtonPrimary
                                  data-plasmic-name={"buttonPrimary"}
                                  data-plasmic-override={
                                    overrides.buttonPrimary
                                  }
                                  color={"brand"}
                                  content={"sign up free"}
                                  onClick={async () => {
                                    const $steps = {};
                                    $steps["goToWebSignupTemp"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            destination: `/signup`
                                          };
                                          return (({ destination }) => {
                                            if (
                                              typeof destination === "string" &&
                                              destination.startsWith("#")
                                            ) {
                                              document
                                                .getElementById(
                                                  destination.substr(1)
                                                )
                                                .scrollIntoView({
                                                  behavior: "smooth"
                                                });
                                            } else {
                                              location.assign(destination);
                                            }
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["goToWebSignupTemp"] != null &&
                                      typeof $steps["goToWebSignupTemp"] ===
                                        "object" &&
                                      typeof $steps["goToWebSignupTemp"]
                                        .then === "function"
                                    ) {
                                      $steps["goToWebSignupTemp"] =
                                        await $steps["goToWebSignupTemp"];
                                    }
                                  }}
                                  showIcon={false}
                                  size={"medium"}
                                  ststus={"normal"}
                                />

                                <ButtonSecondary
                                  data-plasmic-name={"buttonSecondary"}
                                  data-plasmic-override={
                                    overrides.buttonSecondary
                                  }
                                  className={classNames(
                                    "__wab_instance",
                                    sty.buttonSecondary
                                  )}
                                  content={"[ explore the OP gallery ]"}
                                  textColor={"primaryBrand"}
                                />
                              </div>
                            </div>
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img__l8FqN)}
                              displayHeight={"200px"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"none"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"auto"}
                              loading={"lazy"}
                              src={{
                                src: image16HUd1Hbxq734L,
                                fullWidth: 508,
                                fullHeight: 436,
                                aspectRatio: undefined
                              }}
                            />
                          </div>
                        </div>
                      }
                      pageNav={null}
                    />
                  </div>
                }
                tabNav={
                  <Dock
                    data-plasmic-name={"dock"}
                    data-plasmic-override={overrides.dock}
                    className={classNames("__wab_instance", sty.dock)}
                    logoButton={
                      <ButtonNav
                        data-plasmic-name={"iconButton"}
                        data-plasmic-override={overrides.iconButton}
                        className={classNames("__wab_instance", sty.iconButton)}
                        iconForButton={
                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__wcW1J)}
                            displayHeight={"100%"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"none"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"100%"}
                            loading={"lazy"}
                            src={{
                              src: image2RcDhf2RmVmG,
                              fullWidth: 256,
                              fullHeight: 256,
                              aspectRatio: 1
                            }}
                          />
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToHomepage"] = true
                            ? (() => {
                                const actionArgs = { destination: `/` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToHomepage"] != null &&
                            typeof $steps["goToHomepage"] === "object" &&
                            typeof $steps["goToHomepage"].then === "function"
                          ) {
                            $steps["goToHomepage"] =
                              await $steps["goToHomepage"];
                          }
                        }}
                        shape={"fullRounding"}
                        slotSize={"fillButton"}
                      />
                    }
                    logoutButton={
                      <ButtonNav
                        data-plasmic-name={"iconButton2"}
                        data-plasmic-override={overrides.iconButton2}
                        className={classNames(
                          "__wab_instance",
                          sty.iconButton2
                        )}
                        iconForButton={
                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__nyNmM)}
                            displayHeight={"100%"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"none"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"100%"}
                            loading={"lazy"}
                            src={{
                              src: image7MdrMmtCqfnyU,
                              fullWidth: 20,
                              fullHeight: 21,
                              aspectRatio: undefined
                            }}
                          />
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebLogin"] = true
                            ? (() => {
                                const actionArgs = { destination: `/login` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebLogin"] != null &&
                            typeof $steps["goToWebLogin"] === "object" &&
                            typeof $steps["goToWebLogin"].then === "function"
                          ) {
                            $steps["goToWebLogin"] =
                              await $steps["goToWebLogin"];
                          }
                        }}
                        shape={"fullRounding"}
                      />
                    }
                    modulesWrapper={
                      <React.Fragment>
                        <ButtonDock
                          className={classNames(
                            "__wab_instance",
                            sty.buttonDock__pztsf
                          )}
                          iconTab={
                            <Icon6Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__qC6Kc
                              )}
                              role={"img"}
                            />
                          }
                          onClick={async () => {
                            const $steps = {};
                            $steps["goToWebHome"] = true
                              ? (() => {
                                  const actionArgs = { destination: `/home` };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      location.assign(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToWebHome"] != null &&
                              typeof $steps["goToWebHome"] === "object" &&
                              typeof $steps["goToWebHome"].then === "function"
                            ) {
                              $steps["goToWebHome"] =
                                await $steps["goToWebHome"];
                            }
                          }}
                          type={"_default"}
                        />

                        <ButtonDock
                          className={classNames(
                            "__wab_instance",
                            sty.buttonDock___4EJmV
                          )}
                          iconTab={
                            <Icon12Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__m2EZu
                              )}
                              role={"img"}
                            />
                          }
                          onClick={async () => {
                            const $steps = {};
                            $steps["goToWebCompass"] = true
                              ? (() => {
                                  const actionArgs = {
                                    destination: `/compass`
                                  };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      location.assign(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToWebCompass"] != null &&
                              typeof $steps["goToWebCompass"] === "object" &&
                              typeof $steps["goToWebCompass"].then ===
                                "function"
                            ) {
                              $steps["goToWebCompass"] =
                                await $steps["goToWebCompass"];
                            }
                          }}
                          type={"_default"}
                        />
                      </React.Fragment>
                    }
                    variant={"_default"}
                  />
                }
              />
            }
            className={classNames("__wab_instance", sty.appShell)}
            layoutType={"_default"}
          />

          <section className={classNames(projectcss.all, sty.section__q6Ew)}>
            <div className={classNames(projectcss.all, sty.freeBox__nNl6B)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__x8LP
                )}
              >
                {"you're here."}
              </div>
            </div>
          </section>
          <section className={classNames(projectcss.all, sty.section__fe0P2)}>
            <SectionFooter
              data-plasmic-name={"sectionFooter"}
              data-plasmic-override={overrides.sectionFooter}
              className={classNames("__wab_instance", sty.sectionFooter)}
              layout={"withOffset"}
              sectionId={"footer"}
            />
          </section>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "appShell",
    "tabLayout",
    "dock",
    "iconButton",
    "iconButton2",
    "pageLayout",
    "buttonPrimary",
    "buttonSecondary",
    "sectionFooter"
  ],

  appShell: [
    "appShell",
    "tabLayout",
    "dock",
    "iconButton",
    "iconButton2",
    "pageLayout",
    "buttonPrimary",
    "buttonSecondary"
  ],

  tabLayout: [
    "tabLayout",
    "dock",
    "iconButton",
    "iconButton2",
    "pageLayout",
    "buttonPrimary",
    "buttonSecondary"
  ],

  dock: ["dock", "iconButton", "iconButton2"],
  iconButton: ["iconButton"],
  iconButton2: ["iconButton2"],
  pageLayout: ["pageLayout", "buttonPrimary", "buttonSecondary"],
  buttonPrimary: ["buttonPrimary"],
  buttonSecondary: ["buttonSecondary"],
  sectionFooter: ["sectionFooter"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    tabLayout: makeNodeComponent("tabLayout"),
    dock: makeNodeComponent("dock"),
    iconButton: makeNodeComponent("iconButton"),
    iconButton2: makeNodeComponent("iconButton2"),
    pageLayout: makeNodeComponent("pageLayout"),
    buttonPrimary: makeNodeComponent("buttonPrimary"),
    buttonSecondary: makeNodeComponent("buttonSecondary"),
    sectionFooter: makeNodeComponent("sectionFooter"),
    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "OP for my practice.",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
